<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<!--span>
				情况1：<b>已创建Sprint</b>，请选择创建好的<b>Sprint</b>，开始时间、结束时间会自动根据已创建好的<b>Sprint</b>自动填入</br></br>
				情况2：<b>未创建Sprint</b>，<b>Sprint</b>先空着，开始时间、结束时间、工时不填（默认8工时），在添加<b>Sprint</b>时选择该团队即可
			</span-->
			</br>
			<el-form class="dataForm" ref="form" :model="formParameter" :inline="true" label-width="80px"
				:rules="rules">

				<el-row>
					<el-col :span="24">
						<el-form-item label="团队名称" prop="name">
							<el-autocomplete class="inline-input" v-model="formParameter.name"
								:fetch-suggestions="querySearchNm" placeholder="请输入团队名称" @select="handleSelectNm"
								@blur="lostFocus($event)" :trigger-on-focus="false"></el-autocomplete>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="Sprint" prop="header">
							<el-select v-model="spidx" @change="chgSprint" placeholder="规则是先创建Sprint再创建team">
								<el-option v-for="(v, i) in sprintList" :key="i" :value="i" :label="v.spname">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="负责人" prop="header">
							{{ formParameter.header }}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-button v-has-permission-code-and="'003000050005'" size="mini" @click="toAddMember"
							type="warning">添加成员</el-button>
							<span style="margin-left: 15px; color: #FF3333;">(新创建团队时，一定要添加PO！一定要添加PO！一定要添加PO！)</span>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">


						<el-table :data="teamMember" style="width: 100%;">
							<el-table-column prop="dname" label="所在部门" width="150">
								<template slot-scope="scope">
									<!-- scope.row.did -->
									<el-select v-model="scope.row.did" @change="chgDeptArres($event, scope.$index)"
										placeholder="请选择">
										<el-option v-for="(item, idx) in deptArres" :key="idx" :label="item.name"
											:value="idx">
										</el-option>
									</el-select>
								</template>
							</el-table-column>

							<el-table-column prop="username" label="角色" width="130">
								<template slot-scope="scope">
									<el-select :disabled="select2Use[scope.$index]" v-model="scope.row.post"
										@change="chgPostArres($event, scope.$index)" placeholder="请选择">
										<el-option v-for="(itm, index) in postArres" :key="index" :label="itm.name"
											:value="itm.name">
										</el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column prop="username" label="名字" width="130">
								<template slot-scope="scope">
									<!-- scope.row.uid -->
									<el-select :disabled="select3Use[scope.$index]" v-model="scope.row.uid"
										@change="chgEmpArres($event, scope.$index)" placeholder="请选择">
										<el-option v-for="(itm, index) in empArres[scope.$index]" :key="index"
											:label="itm.name" :value="index">
										</el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column prop="starttime" label="开始时间">
								<template slot-scope="scope">
									<el-date-picker v-model="scope.row.starttime" @change="chgTime(1, scope.row)"
										type="date" placeholder="选择日期">
									</el-date-picker>
								</template>
							</el-table-column>
							<el-table-column prop="endtime" label="结束时间">
								<template slot-scope="scope">
									<el-date-picker v-model="scope.row.endtime" @blur="chgEndTime(scope.row)"
										type="date" placeholder="选择日期">
									</el-date-picker>
								</template>
							</el-table-column>
							<el-table-column prop="hour4day" label="工时" width="85">
								<template slot-scope="scope">
									<el-input v-model="scope.row.hour4day"
										@blur="checkMemberTime(scope.row, scope.$index)" autocomplete="off"></el-input>
								</template>
							</el-table-column>
							<el-table-column prop="mobile" label="信息" width="180">
								<template slot-scope="scope">
									性别：{{ scope.row.sex }}<br />
									电话：{{ scope.row.mobile }}
								</template>
							</el-table-column>
							<el-table-column label="操作" width="80">
								<template slot-scope="scope">
									<el-button size="mini" type="danger" v-has-permission-code-and="'003000050005'"
										@click="delteamMember(scope.$index)">删除</el-button>
								</template>
							</el-table-column>

						</el-table>
					</el-col>

				</el-row>
			</el-form>
		</div>
		<div slot="footer">
			
			<el-button type="primary" v-has-permission-code-and="'003000050005'" :loading="confirmLoading"
				@click="confirm()">确
				定</el-button><el-button @click="close">取 消</el-button>

		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/team/team/team.js';
import spApi from '@/api/sprint/sprint/sprint.js';
import apiDpt from '@/api/system/department/department.js';
import postapi from '@/api/components/biz/selectOptionDictionary/selectOptionDictionary.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import { watch } from 'vue';


export default {
	name: 'edit',
	components: {
		popup,
		selectOptionDictionary,
	},
	data() {
		return {

			disabled: true,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},      //主页面不会传递数据到这里

			formParameter: {},  //team
			teamMember: [],	     //team成员  [{},{}..]

			deptArres: [],       //备选的部门  [{},{}..]
			empArres: [],        //备选的员工  [[{},{}..],[]..]  2维数组

			postArres: [],		 //备选职位
			postBackup: [],		//职位备份，当删除sm时还原到备选职位
			select2Use: [],      //只能按照顺序选择
			select3Use: [],      //只能按照顺序选择

			sprintList: [], //备选的Sprints
			spidx: '',      //选中的Sprints 序号

			sprint: '',
			isAdd: true,    //新增还是配置
			allSprints: false,    //加载SprintList是不是在感应范围内
			isSelectTeam: false,
			teamList: [],
			dontShow: true,


			saveTeamParam: {
				teamInfo: {},
				teamMembers: [],
			},
			updateTeamParam: {
				teamInfo: {},
				teamMembers: [],
				id: "",
			},
			delMember: {},
			rules: {
			}
		};
	},
	methods: {
		chgEndTime() {

			this.formParameter.header = "dsadasda"
			this.$forceUpdate()

		},
		chgTime(type, row) {

			if (!row.starttime) {
				this.$utils.msg.warning("输入开始时间不能为空");
				row.starttime = new Date(this.sprint.stm)
				return false
			}
			if (!row.endtime) {
				this.$utils.msg.warning("输入结束时间不能为空");
				row.endtime = new Date(this.sprint.etm)
				return false
			}

			if (typeof (row.starttime) == "string") {
				row.starttime = new Date(new Date(row.starttime).getTime() - 28800000)
			}

			if (typeof (row.endtime) == "string") {
				row.endtime = new Date(new Date(row.endtime).getTime() - 28800000)
			}

			let this_stm = row.starttime.getTime()
			let this_etm = row.endtime.getTime()
			let sprint_stm = new Date(this.sprint.stm).getTime() - 28800000
			let sprint_etm = new Date(this.sprint.etm).getTime() - 28800000


			console.log(this_stm, sprint_stm, "|", this_etm, sprint_etm);

			if (this_stm - this_etm > 0) {
				this.$utils.msg.warning("输入开始时间不能大于结束时间");
				row.starttime = new Date(this.sprint.stm)
				row.endtime = new Date(this.sprint.etm)
				return false
			}

			if (type == 1) {  //开始时间
				if (this_etm != this_stm && (this_stm < sprint_stm || this_stm > sprint_etm)) {
					this.$utils.msg.warning("输入开始时间错误");
					//重置
					row.starttime = new Date(this.sprint.stm)
				}
			} else {

				console.log((this_etm != this_stm), '||', (this_etm < sprint_stm), '||', (this_etm > sprint_etm));
				if (this_etm != this_stm && (this_etm < sprint_stm || this_etm > sprint_etm)) {
					this.$utils.msg.warning("输入结束时间错误");
					//重置
					row.endtime = new Date(this.sprint.etm)
				}
			}
		},


		//输入框失去焦点执行,选择了建议列表也算失去焦点
		lostFocus(event) {
			//如果不输入数据
			if (typeof this.formParameter.name === 'undefined') {
			} else {
				//输入框已输入数据，判断是否选择了建议列表
				if (this.isSelectTeam == false) {
					//如果没有手动选择建议列表则进行判断已输入的名称是否已经存在该名称的团队
					console.log("已查询的团队列表", this.teamList);
					let isOldTeam = false;
					let exitTeaminfo = {};
					for (let i = 0; i < this.teamList.length; i++) {
						//从建议列表的数据判断输入的数据是不是已存在的团队
						if (this.formParameter.name == this.teamList[i].name) {
							isOldTeam = true;
							exitTeaminfo = this.teamList[i];
							break;
						}
					}
					if (isOldTeam == true) {
						//已存在的团队
						//this.handleSelectNm(exitTeaminfo);
						this.isAdd = false;
						//取回选中的团队 准备克隆一个新的
						api.getMembers({ tid: exitTeaminfo.id }, response => {
							console.log("根据已有团队id查询的所有信息", response);
							//team
							this.formParameter.id = exitTeaminfo.id
							this.formParameter.header = response.data.teamInfo.header;
							if (response.data.unTeamSprints) {
								//取回本团队 的 Product 下没有分配team的Sprints
								this.sprintList = response.data.unTeamSprints
							}
							this.teamMember = []

							for (let idx = 0; idx < response.data.teamMemberInfo.length; idx++) {
								this.select2Use.push(true);
								this.select3Use.push(true);
							}
							//teamMember
							for (let idx = 0; idx < response.data.teamMemberInfo.length; idx++) {
								this.teamMember.push({
									did: response.data.teamMemberInfo[idx].dept,
									post: response.data.teamMemberInfo[idx].post,
									uid: response.data.teamMemberInfo[idx].name,
									usrid: response.data.teamMemberInfo[idx].usrid,
									sex: response.data.teamMemberInfo[idx].sex == 1 ? "男" : "女",
									mobile: response.data.teamMemberInfo[idx].mobile,
								})

							}
						}
						);
					} else {
						//新的团队
						console.log("来到了这里");
						spApi.listUnTeamed({}, res => {
							console.log("所有未分配团队的sprint", res);
							// 没有分配team的Sprints	
							this.allSprints = true
							this.sprintList = res.data
							delete this.formParameter.id
							this.isAdd = true
							this.disabled = this.sprintList.length > 0
							this.spidx = ''
						})
					}
					//console.log(a);
				} else {
					//如果已经手动选择则什么都不做
				}
				//输入了数据则查询
				//console.log(this.formParameter.name);
			}


		},

		//team Name联动查询
		querySearchNm(queryString, cb) {
			console.log("发起请求进行查询", queryString);
			// 每次输入都向后端发起模糊查询查询,若有相关团队则放入建议列表
			this.teamList = [];
			this.isSelectTeam = false;
			this.teamMember = [];
			api.listInts({ tnm: queryString }, res => {
				let results = res.data
				console.log("查询到的信息", results)
				if (results && results.length > 0) {
					//将查到的数据放入teamList 方便没有选择建议列表的团队时 失去焦点后判断是否是已存在的团队
					this.teamList = results;
					this.allSprints = false
					results.forEach(v => v.value = v.name)
					// 调用 callback 返回建议列表的数据
					results = results.sort();
					var arrry = [results[0]];
					for (var i = 1; i < results.length; i++) {
						if (results[i] !== results[i - 1]) {
							arrry.push(results[i]);
						}
					}
					cb(arrry);
				} else {
					//加载Sprint备选列表
					if (!this.allSprints) {
						spApi.listUnTeamed({}, res => {
							console.log("所有未分配团队的sprint", res);
							// 没有分配team的Sprints	
							this.allSprints = true
							this.sprintList = res.data
							delete this.formParameter.id
							this.isAdd = true
							this.disabled = this.sprintList.length > 0
							this.spidx = ''
						})
					}

				}
			})
		},
		//选择建议列表的团队（选择已有团队）触发
		handleSelectNm(item) {
			this.isAdd = false;
			//表明手动选择的建议列表的团队，不再执行失去焦点方法
			this.isSelectTeam = true;
			api.getMembers({ tid: item.id }, response => {

				console.log("根据已有团队id查询的所有信息", response);
				//team
				this.formParameter.id = item.id
				this.formParameter.header = response.data.teamInfo.header;
				if (response.data.unTeamSprints) {
					//取回本团队 的 Product 下没有分配team的Sprints
					this.sprintList = response.data.unTeamSprints
				}
				this.teamMember = []

				for (let idx = 0; idx < response.data.teamMemberInfo.length; idx++) {
					this.select2Use.push(true);
					this.select3Use.push(true);
				}



				//teamMember
				for (let idx = 0; idx < response.data.teamMemberInfo.length; idx++) {

					this.teamMember.push({
						did: response.data.teamMemberInfo[idx].dept,
						post: response.data.teamMemberInfo[idx].post,
						uid: response.data.teamMemberInfo[idx].name,
						usrid: response.data.teamMemberInfo[idx].usrid,
						sex: response.data.teamMemberInfo[idx].sex == 1 ? "男" : "女",
						mobile: response.data.teamMemberInfo[idx].mobile,
					})


				}
				console.log("原团队成员", this.teamMember);
			}
			);
		},
		//选择列表的sprint后触发
		chgSprint() {
			this.sprint = this.sprintList[this.spidx]
			this.formParameter.sid = this.sprint.spid

			if (this.isAdd) {
				this.teamMember = []
				this.select2Use.push(true);
				this.select3Use.push(true);
				this.teamMember.push({

					did: this.sprint.dname,
					post: "PO",
					uid: this.sprint.usrnm,
					sex: this.sprint.sex == '1' ? "男" : "女",
					mobile: this.sprint.mobile,
					starttime: this.sprint.stm,
					endtime: this.sprint.etm
				});
			} else {
				//成员生效时间
				this.teamMember.forEach(v => {
					//v.starttime = 
					//v.endtime = this.sprint.etm
					this.$set(v, "starttime", this.sprint.stm)
					this.$set(v, "endtime", this.sprint.etm)
					this.$set(v,"hour4day","8")
				})
				//console.log("this.teamMember",this.teamMember)
				//强制刷新数组
				//setTimeout(this.$forceUpdate(),100)

			}


		},
		//工时框失去焦点时触发
		checkMemberTime(row, idx) {
			console.log("改行的数据", row);
			if (row.hour4day * 1 <= 0 || row.hour4day * 1 > 8) {
				this.$utils.msg.warning("输入值错误");
				row.hour4day = ""
				return false;
			}
			api.checkMemberTime({
				mobile: row.mobile,
				starttime: row.starttime,
				endtime: row.endtime,
				hour4day: (row.hour4day ? row.hour4day : 0)
			}, res => {
				// do nothing!
			}, err => {
				let maxHours = 8 - err.msg * 1;
				this.$utils.confirm.warning('提示,配置工时冲突', '最大值只能是:' + maxHours, () => {
					row.hour4day = (maxHours == 0 ? "" : maxHours)
				});
			})


		},

		//下拉部门列表
		//		idx2下拉表单中的行，idx列表的第几行
		chgDeptArres(idx2, idx) {
			this.select2Use[idx] = false;

			let dpt = this.deptArres[idx2]
			//取回员工                     为保证请求参数不一样
			apiDpt.deptEmps({ did: dpt.id, idx: idx }, res => {
				//备选的员工 [[{},{}..],[],[]..]
				this.empArres[idx] = res.data
				this.$set(this.empArres, this.empArres[idx], res.data);
				let repeatEmps = []
				//此人是否已存在
				this.empArres[idx].forEach((v, i) => {
					for (let index = 0; index < this.teamMember.length; index++) {
						//console.log("v.name",v.name,"this.teamMember[index].name",this.teamMember[index])
						//排除之前已加过
						if (v.name == this.teamMember[index].uid) {
							repeatEmps.push(i)
						}
					}
				})

				console.log('this.empArres ', this.empArres);
				console.log("repeatEmps", repeatEmps)
				//如果存在重复
				if (repeatEmps.length > 0) {
					for (let rptIdx = 0; rptIdx < repeatEmps.length; rptIdx++) {
						const pos = repeatEmps[rptIdx];
						//相对位置  删除一个
						this.empArres[idx].splice(pos - rptIdx, 1)
					}
				}
				//强制刷新
				//setTimeout(this.$forceUpdate(), 5);

			})
			//this.$forceUpdate();
		},
		//选择角色职位后触发
		chgPostArres(idx2, idx) {//idx2是选中的数据
			this.select3Use[idx] = false;
			console.log("*****************", idx2, idx);
		},
		//选择名字后触发 选择查询到的信息
		chgEmpArres(idx2, idx) {
			console.log("选择名字后", idx2, idx);

			let emp = this.empArres[idx][idx2]
			this.teamMember[idx].mobile = emp.mobile
			this.teamMember[idx].uid = emp.name
			this.teamMember[idx].sex = emp.sex == 1 ? '男' : '女'
			console.log("this.teamMember[idx].post ", this.teamMember[idx].post)
			console.log("emp.name ", emp.name)
			//如果是SM
			if (this.teamMember[idx].post == 'SM') {
				this.$set(this.formParameter, "header", emp.name)
			}
		},
		//打开弹框初始化内容
		open(parameter, title, size) {

			console.log('this.sprintList ', this.sprintList);
			this.$set(this, 'sprintList', []);
			console.log('this.sprintList ', this.sprintList);
			this.parameter = parameter;  //添加并没有传输数据，添加页面与编辑页面不共用同一个页面
			this.$refs.popup.open(title, "1200px");

			this.formParameter = {};
			this.postArres = [];
			this.postBackup = [];
			this.teamMember = [];
			this.sprintList = [];
			this.select2Use = [];
			this.select3Use = [];
			postapi.list({ dkey: 'scrum-roles' }, res => {
				console.log("返回的部门列表信息", res);
				for (let i = 0; i < res.data.length; i++) {
					this.postBackup.push({ name: res.data[i].dvalue })
					this.postArres.push({ name: res.data[i].dvalue })
				}
				//this.postArres = this.postBackup;
				console.log("存放的角色列表信息", this.postArres);
			})

			//清楚校验
			//this.$refs.form.clearValidate();
			apiDpt.listAll({}, res => {
				this.deptArres = res.data
			})

		},
		//关闭弹框
		close() {
			this.spidx = '';
			this.sprint = '';
			this.sprintList = [];
			this.formParameter = {};
			this.teamMember = [];
			this.deptArres = [];
			this.empArres = [];
			this.teamList = [];
			//刷新一下页面
			this.$refs.popup.close();
		},
		//提交表单
		confirm() {
			this.$utils.checkForm(this.$refs.form, () => {
				this.confirmLoading = true;

				//添加
				// let parameter = this.$utils.merger(this.formParameter);
				//将"男"转成1,"女"转换成2，uid变成了用户名字，再把uid赋值给name
				let tempteamMember = this.teamMember
				for (let i = 0; i < tempteamMember.length; i++) {
					if (tempteamMember[i].sex === '男') {
						tempteamMember[i].sex = 1;
						tempteamMember[i].name = tempteamMember[i].uid;
					} else {
						tempteamMember[i].sex = 2;
						tempteamMember[i].name = tempteamMember[i].uid;
					}
				}

				delete this.formParameter.id

				let saveTeamParam = {
					teamInfo: this.formParameter,
					teamMembers: tempteamMember
				};
				console.log("请求发送的数据", saveTeamParam);
				api.saveTeam(saveTeamParam,
					response => {
						this.$utils.msg.success(response.msg);
						this.confirmLoading = false;
						this.close();
						this.$parent.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
						this.confirmLoading = false;
					}
				);

			});
		},
		//添加人员
		toAddMember() {
			/* postapi.list({ dkey: 'scrum-roles2' }, res => {
					console.log("返回的部门列表信息", res);
					for (let i = 0; i < res.data.length; i++) {
						this.postBackup.push({name:res.data[i].dvalue})
					}
				}) */
			if (this.teamMember && this.teamMember.length > 0) {
				let first = this.teamMember[0]
				this.teamMember.push({ starttime: first.starttime, endtime: first.endtime });
				//如果团队已经有sm在备选列表去掉
				for (let i = 0; i < this.teamMember.length; i++) {
					console.log("this.teamMember[i].post=='SM'", this.teamMember[i].post == 'SM');
					if (this.teamMember[i].post == 'PO') {
						for(let j = 0; j < this.postArres.length ; j++){
							if(this.postArres[j].name == 'PO'){
								this.postArres.splice(j, 1);
							}
						}	
					}
					if (this.teamMember[i].post == 'SM') {
						for(let j = 0; j < this.postArres.length ; j++){
							if(this.postArres[j].name == 'SM'){
								this.postArres.splice(j, 1);
							}
						}
						console.log("剩余可选角色列表", this.postArres);
					}
				}
			} else {
				this.teamMember.push({});
			}

			this.select2Use.push(true);
			this.select3Use.push(true);

		},
		//删除添加的团队成员
		delteamMember(idx) {
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				console.log("this.teamMember[idx].post=='SM'", this.teamMember[idx].post == 'SM');
				console.log("this.postBackup", this.postBackup);
				if (this.teamMember[idx].post == 'SM') {
					//this.$set(this, 'postArres', this.postBackup);
					this.postArres = this.postBackup;
					console.log("剩余可选角色列表", this.postArres);
				}
				this.teamMember.splice(idx, 1);
				this.select2Use.splice(idx, 1);
				this.select3Use.splice(idx, 1);
				//this.empArres.splice(idx, 1)
			});

		}
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';
</style>
